import {SelectionModel} from '@angular/cdk/collections';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AfterViewChecked, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {MatMenuTrigger} from '@angular/material/menu';
import {MatPaginator} from '@angular/material/paginator';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatSort} from '@angular/material/sort';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';
import {MatTableDataSource} from '@angular/material/table';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import {MatSliderModule} from '@angular/material/slider';
import {ErrorStateMatcher} from '@angular/material/core';

import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {environment} from 'src/environments/environment';
import {TraslateService} from 'src/app/traslate.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {NgxMaterialTimepickerTheme} from 'ngx-material-timepicker';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-plannification-report',
  templateUrl: './plannification-report.component.html',
  styleUrls: ['./plannification-report.component.scss']
})
export class PlannificationReportComponent implements OnInit, AfterViewChecked {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  tableDataSource: { SubValue: string; name: string; dateCreation: string; typeExport: string }[];

  collection: any = [];
  lengthpage: number = 100;
  pageSizeOptions1: number[];
  pageNum: any;
  manualPage: number = 0;

  manualPage1: number;
  public currentPage = 0;
  public totalSize = 0;
  pageSizeOptions = [5, 10, 25];
  pageSize1: any;
  pageSize: any = 10;
  index2: any = 10
  selection = new SelectionModel<any>(true, []);
  selectedRow;
  selected: boolean;
  ItemSelected: any[] = [];
  rangeForm = new FormGroup({
    start: new FormControl(new Date(localStorage.getItem("startDateValue"))),
    end: new FormControl(new Date(localStorage.getItem("endDateValue"))),
  });
  DateStart: string;
  DateEnd: string;
  minDate: Date = new Date(2010, 1, 1);
  maxDate: Date = new Date();
  highlighted = false;
  selectedRowIndex: number = -1;

  displayedColumns = ["select", "filter_name", "typeExport", "filter_type", "created_at", "action"];
  dataSource = new MatTableDataSource();

  @ViewChild(MatMenuTrigger)
  contextMenu: MatMenuTrigger;

  contextMenuPosition = {x: '0px', y: '0px'};
  CodePostal: any;
  Nom: any;
  Groupe: any;


  myModel = true;

  veh: boolean = true;
  scr: boolean = true;
  rep_plan_List: any;
  dataSourceRp: MatTableDataSource<unknown>;
  arr: any[];


  constructor(private _formBuilder: FormBuilder, private _snackBar: MatSnackBar, public dialog: MatDialog, private fb: FormBuilder, private http: HttpClient, private spinnerFavorisrep: NgxSpinnerService, public traslateService: TraslateService,
              private cdRef: ChangeDetectorRef) {

    /*  this.http.get<any>('http://my-json-server.typicode.com/Hafsabo/jsonserver/db').subscribe(data => {
       this.tableDataSource= data.posts
       this.dataSource = new MatTableDataSource(this.tableDataSource);
     //console.log(this.tableDataSource )})
     this.dataSource.paginator = this.paginator;
     this.dataSource.sort = this.sort; */

    this.getReportPlan(15, "")


  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  async ngOnInit(): Promise<void> {


    /*  this.http.get<any>('http://my-json-server.typicode.com/Hafsabo/jsonserver/db').subscribe(data => {
       //console.log(data.posts)
       this.dataSource = new MatTableDataSource(data.posts);
       this.tableDataSource= data.posts;
       this.dataSource.paginator = this.paginator;
     this.dataSource.sort = this.sort;

     }) */
  }


  onContextMenu(event: MouseEvent, item: any) {
    event.preventDefault();
    this.contextMenuPosition.x = event.clientX + 'px';
    this.contextMenuPosition.y = event.clientY + 'px';
    this.contextMenu.menuData = {'item': item};
    this.contextMenu.menu.focusFirstItem('mouse');
    this.contextMenu.openMenu();
  }

  onContextMenuAction1(item: any) {
    alert(`Click on Supprimer for ${item.name}`);
  }

  onContextMenuAction2(item: any) {
    alert(`Click on Modifier for ${item.name}`);
  }

  onContextMenuAction3(item: any) {
    alert(`Click on Activer/Désactiver for ${item.name}`);
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected?.length;
    const numRows = this.dataSource.data?.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {

    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => {
        this.selection.select(row);
      });
  }


  executeFunction() {
    //console.log(this.rangeForm)

    this.addNewDate(this.rangeForm);
  }

  addNewDate(e) {
    this.DateStart = new Date(e.value.start)
      ?.toString()
      .split("(")[0]
      .split("GMT")[0];
    //this.minDate = new Date(e.value.start)

    //var DateEnd2 = new Date(e.value.end)?.toISOString();
    this.DateEnd = new Date(e.value.end)
      ?.toString()
      .split("(")[0]
      .split("GMT")[0];
    //console.log(this.DateStart, this.DateEnd)
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {

    if (!row) {

      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;

    }
    this.ItemSelected = this.selection.selected

    ////console.log(this.ItemSelected)


    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;

  }

  pageChanged(event) {

    console.log(" pageChanged(event)  pageChanged(event) ")
    console.log(event);
    let pageIndex = event.pageIndex;
    let pageSize = event.pageSize;

    let previousIndex = event.previousPageIndex;

    let previousSize = pageSize * pageIndex;
    console.log("pageSize");
    console.log(pageSize);

    console.log("pageIndex");
    console.log(pageIndex);


    this.getReportPlan(previousSize, (pageIndex + 1).toString());


  }


  getReportPlan(currentSize, offset) {


    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.http.get(environment.apiUrl + '/reports/scheduler', requestOptions).subscribe((response: any) => {
        ////console.log(response)
        this.rep_plan_List = response;
        ////console.log('contactList          '+this.contactList);

        var list: any = response.data

        this.rep_plan_List = response.data
        this.rep_plan_List.push(...list);

        if (currentSize == 0) {
          list.length = 15;
        } else {
          list.length = currentSize;
        }

        this.rep_plan_List = response.data
        this.rep_plan_List.push(...list);
        this.rep_plan_List.length = response.total


        this.dataSource = new MatTableDataSource(this.rep_plan_List);
        this.tableDataSource = this.rep_plan_List;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;


      },
      (error) => {
        Swal.fire({
          text: 'Un problème est survenu! ' + error,

        })

      })
  }


  GetSelectedRow(row) {
    if (this.selectedRowIndex === row.id) {
      this.selectedRowIndex = -1;
      this.selected = false;


    } else {

      this.selectedRow = row;
      this.selectedRowIndex = row.id;
      this.selected = true;

      //console.log("hello " + this.selectedRowIndex);
    }
  }

//filtre global

  applyFilter(event: Event) {
    this.dataSource = new MatTableDataSource(this.tableDataSource)

    const filterValue = (event.target as HTMLInputElement).value;
    //console.log( this.dataSource)
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


  ngAfterViewInit() {

    // this.updateManualPage2(this.index2)

  }

  public updateManualPage2(index2) {

    this.collection = []

    //console.log(this.pageSizeOptions1)
    this.paginator.pageSize = index2

    this.paginator.page.next({
      pageIndex: this.paginator.pageIndex,
      pageSize: index2,
      length: this.paginator.length
    });
//console.log('jjjj')


    this.lengthpage = parseInt("" + 30 / index2)

    //console.log(this.lengthpage)

    //Create dummy data
    for (var i = 0; i < this.lengthpage; i++) {
      this.collection.push(i + 1);
    }

    //console.log(this.collection)

  }

  public updateManualPage(index): void {
    //console.log(index)
    this.pageNum = index
    this.manualPage = index;
    this.paginator.pageIndex = index;

    this.paginator.page.next({
      pageIndex: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize,
      length: this.paginator.length
    });


  }

  supprimerRapport() {

    this.arr = []
    this.selection.selected.forEach(el => {

      this.arr.push(el.id);

    })

    if (this.ItemSelected.length === 1) {


      Swal.fire({
        title: "Voulez-vous supprimer cette planification ?",
        text: "Vous êtes sur le point de supprimer une planification des rapports!",
        showCancelButton: true,
        confirmButtonColor: '#262756',
        cancelButtonColor: "#e05a61",
        confirmButtonText: 'Confirmer!'
      }).then((result) => {
        if (result.isConfirmed) {

          this.spinnerFavorisrep.show();
          this.http.delete(environment.apiUrl + '/reports/scheduler/[' + this.arr + ']').subscribe((response) => {
              //console.log(response)
              var resp: any = response
              if (resp.status == 200) {
                //console.log(environment.apiUrl+'/reports/scheduler/['+this.arr+']')


                this.selection.clear();
                //this.lengthItem =0
                this.getReportPlan(15, "")
                Swal.fire(
                  '',
                  resp.message
                )
              } else {


                Swal.fire({
                  text: 'Une erreur est survenue lors de la suppression',

                })

              }
              this.spinnerFavorisrep.hide();

            },
            (error) => {
              Swal.fire({
                text: 'Un problème est survenu! ' + error,

              })

              this.spinnerFavorisrep.hide();
            })
        }
      })

    } else if (this.ItemSelected.length >= 1) {

      Swal.fire({
        title: "Voulez-vous supprimer ces planifications des rapports ?",
        text: "",
        showCancelButton: true,
        confirmButtonColor: '#262756',
        cancelButtonColor: "#e05a61",
        confirmButtonText: 'Confirmer!'
      }).then((result) => {
        if (result.isConfirmed) {

          this.spinnerFavorisrep.show();
          this.http.delete(environment.apiUrl + '/reports/scheduler/[' + this.arr + ']').subscribe((response) => {
              //console.log(response)
              var resp: any = response
              if (resp.status == 200) {
                //console.log(environment.apiUrl+'/reports/scheduler/['+this.arr+']')


                this.selection.clear();
                //this.lengthItem =0
                this.getReportPlan(15, "")
                Swal.fire(
                  '',
                  resp.message
                )
              } else {


                Swal.fire({
                  text: 'Une erreur est survenue lors de la suppression',

                })

              }
              this.spinnerFavorisrep.hide();

            },
            (error) => {
              Swal.fire({
                text: 'Un problème est survenu! ' + error,

              })

              this.spinnerFavorisrep.hide();
            })
        }
      })

    } else {

      Swal.fire({
        title: 'Veuillez selectionner un enregistrement'
      })

    }

  }

  arrfvr: any = []

  supprimerRapport_RightClick(operation, id) {
    this.arrfvr = []
    if (operation == 'oneItem') {
      this.selection.clear()
      this.ItemSelected = []
      this.arr = []
      this.ItemSelected.push({
        id: id,
      })
    }
    for (var i = 0; i < this.ItemSelected.length; i++) {
      var obj = {}; // <---- Move declaration inside loop

      obj['id'] = this.ItemSelected[i].id;

      this.arrfvr.push(this.ItemSelected[i].id);
    }

    Swal.fire({
      title: "Voulez-vous supprimer ce rapport?",
      text: "Vous êtes sur le point de supprimer ce rapport!",
      showCancelButton: true,
      confirmButtonColor: '#262756',
      cancelButtonColor: "#e05a61",
      confirmButtonText: 'Confirmer!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.spinnerFavorisrep.show();
        console.log(this.arrfvr);
        // ['+e+']'
        this.http.delete(environment.apiUrl + '/reports/scheduler/[' + this.arrfvr + ']').subscribe((response) => {
            //console.log(response)
            var resp: any = response
            if (resp.status == 200) {
              //console.log(environment.apiUrl+'/reports/scheduler/['+e+']')


              this.selection.clear();
              //this.lengthItem =0
              this.getReportPlan(15, "")
              Swal.fire(
                '',
                resp.message
              )
            } else {


              Swal.fire({
                text: 'Une erreur est survenue lors de la suppression',

              })

            }
            this.spinnerFavorisrep.hide();

          },
          (error) => {
            Swal.fire({
              text: 'Un problème est survenu! ' + error,

            })

            this.spinnerFavorisrep.hide();
          })
      } else {
        this.selection.clear()
        this.arrfvr = []
        this.ItemSelected = []
        this.arr = []
      }
    })


  }

  modifierRapport(element) {


    this.ItemSelected = this.selection.selected
    let dialogRef = this.dialog.open(DialogEditplanrep, {

      disableClose: true,

      data: {
        animal: 'panda'
      },
      width: '70%',
      height: '80%',
      panelClass: 'my-custom-dialog-class'
    });

    this.traslateService.reportplanQuote.next(element)
    dialogRef.afterClosed().subscribe(result => {
      this.selection.clear()
      this.ItemSelected = []
      this.arr = []

    });
    //console.log(this.ItemSelected)

    for (let e of this.ItemSelected) {
      //console.log(e.CodePostal)
      this.CodePostal = e.CodePostal
      this.Groupe = e.Groupe
      this.Nom = e.name

    }


  }

  AjouterRapport() {
    this.dialog.open(DialogAddplanrep, {
      disableClose: true,
      data: {
        animal: 'panda'
      },
      height: '70%',
      panelClass: 'my-custom-dialog-class'
    });


  }

  modifierRapport_RightClick(e) {


    this.ItemSelected = this.selection.selected
    this.dialog.open(DialogEditplanrep, {
      disableClose: true,
      data: {
        animal: 'panda'
      },
      width: '70%',
      height: '70%',
      panelClass: 'my-custom-dialog-class'
    });

    this.traslateService.UserAlarmEventQuote.next(this.ItemSelected)
    //console.log(this.ItemSelected)

    for (let e of this.ItemSelected) {
      //console.log(e.CodePostal)
      this.CodePostal = e.CodePostal
      this.Groupe = e.Groupe
      this.Nom = e.name

    }


  }


}

@Component({
  selector: 'dialog-elements-example-dialog',
  styleUrls: ['./plannification-report.component.scss'],
  templateUrl: 'Editplan.html',
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: {displayDefaultIndicatorType: false}
  }]
})
export class DialogEditplanrep implements OnInit {
  toppings = new FormControl();
  toppingList: string[] = ['Rapport1', 'Rapport2', 'Rapport3', 'Rapport4', 'Rapport5', 'Rapport6'];
  selected: any
  selected1: any
  selected2: any
  selected3: any
  value: any
  nbr: any
  sliderValue: number;
  sliderValue1: number;
  hiddenContact: string;
  pageSize: any = 3
  pageSizeOptions: any = [3, 9, 12]
  dataSourcet: any;
  contactList: any = ""
  displayedColumnst: string[] = ['position'];
  displayedColumnrep: string[] = ['position1'];
  dataSourcetrep: any;
  displayedColumns: string[] = ['first_name', 'last_name', 'email', 'delete'];
  myControl = new FormControl();
  myControl1 = new FormControl();
  lengthTotal: any;
  repos: any;
  dataSource: MatTableDataSource<unknown>;
  matcher = new MyErrorStateMatcher();
  tableDataSourceContact: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild('secondPaginator', {static: true}) secondPaginator: MatPaginator;

  @ViewChild('secondPaginator2', {static: true}) secondPaginator2: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;
  contact_notif2: any = [];
  contacts = new FormControl();
  contact_notif: any = [];
  contact_notif3: any = [];
  selectedRowIndex2: any;
  itemSelect2: any;
  selectedRow;
  selectedd: boolean;
  ItemSelected: any[];

  first_name: any;
  last_name: any;
  email: any;
  new_contact: boolean;
  submitStatus: boolean;
  selection = new SelectionModel<any>(true, []);
  dataSourceC: MatTableDataSource<unknown>;
  url: any;
  periode: any;
  itemSelect3: any;
  frequence: any
  date1: any
  wkDay: any
  day1: any
  day2: any
  heure: any
  public startAt = new Date();
  public min = new Date();
  public startMoment = new Date(0, 0, 0);
  rapport: any;
  filter_id: any;
  hiddenrep: string;
  fav_repos_List: any;
  contactList1: any;
  date: any;
  idPlan: any;

  darkTheme: NgxMaterialTimepickerTheme = {
    container: {
      bodyBackgroundColor: '#424242',
      buttonColor: '#fff'
    },
    dial: {
      dialBackgroundColor: '#555',
    },
    clockFace: {
      clockFaceBackgroundColor: '#555',
      clockHandColor: '#9fbd90',
      clockFaceTimeInactiveColor: '#fff'
    }
  };

  ngOnInit(): void {

    this.traslateService.reportplandataQuote.subscribe(data => {
      this.url = data
      console.log("data", data)
    });
    this.itemSelect3 = this.url.filter_id
    this.rapport = this.url.filter_name
    this.frequence = this.url.frequency
    this.periode = this.url.period
    this.date1 = this.url.date
    this.date = this.url.date
    this.wkDay = this.url.wkDay
    this.day1 = this.url.day1
    this.day2 = this.url.day2
    this.heure = this.url.hour
    this.contacts = this.url.contacts

    this.selected1 = this.url.period

    this.selected3 = this.url.wkDay

    this.filter_id = this.url.filter_id
    this.idPlan = this.url.id
    this.contact_notif3 = this.url.contacts


    this.getContactsN(this.url)
    //
    this.getContactSelect()
    //

  }


  constructor(public dialogRef: MatDialogRef<DialogEditplanrep>, private _formBuilder: FormBuilder, public traslateService: TraslateService, private http: HttpClient, private formBuilder: FormBuilder, private _snackBar: MatSnackBar, private spinnerFavorisrep: NgxSpinnerService) {
    this.getItem()
    // this.getContact()
    // this.getContact_notif()
    this.getContactSelect()
    this.getreportSelect()


    this.traslateService.reportplandataQuote.subscribe(data => {
      this.url = data
      //console.log(this.url)
      //console.log(data)


      this.itemSelect3 = this.url.filter_id
      this.filter_id = this.url.filter_id
      this.idPlan = this.url.id
      this.rapport = this.url.filter_name
      this.frequence = this.url.frequency
      this.periode = this.url.period
      this.date1 = this.url.date
      this.date = this.url.date
      this.wkDay = this.url.wkDay
      this.day1 = this.url.day1
      this.day2 = this.url.day2
      this.heure = this.url.hour
      this.contacts = this.url.contacts


      //console.log(this.idPlan)
      //console.log( this.url.contacts)


    })


    this.url


    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    //console.log(JSON.parse(localStorage.getItem('currentUser')).company_id)
    this.http.get(environment.apiUrl + '/companies/' + JSON.parse(localStorage.getItem('currentUser')).company_id + '/contacts', requestOptions).subscribe((response) => {

        var listContacts: any = response

        this.lengthTotal = listContacts.length


        this.repos = listContacts
        // //console.log(this.repos)


        this.dataSource = new MatTableDataSource(this.repos);
        this.dataSource.paginator = this.paginator;
        this.tableDataSourceContact = this.repos;
        this.dataSource.sort = this.sort;


      },
      (error) => {
        Swal.fire({
          text: 'Un problème est survenu! ' + error,

        })


      })


  }


  add_contact() {
    this.new_contact = !this.new_contact
  }

  getContactsN(e) {
//console.log(e.contacts)
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.http.get(environment.apiUrl + '/companies/' + JSON.parse(localStorage.getItem('currentUser')).company_id + '/contacts', requestOptions).subscribe((response:any) => {
        ////console.log(response)
        this.contactList1 = response;

        ////console.log('contactList          '+this.contactList);
        //console.log(this.contactList1)
        /*
           for (let index = 0; index < this.contactList1.length; index++)
          {
           //console.log(this.contact_notif1)
           this.contact_notif = this.contactList1[index];
           this.contact_notif.filter((x) => {
             //console.log(this.contact_notif1)
             for(let i in e.contacts){
               if (x.id === i) {

                 this.contact_notif1.push(x)
               }
             }

           });


          } */
        for (let i of e.contacts) {
          //console.log(i)
          //console.log(this.contactList1)

          /*  this.contact_notif=this.contactList1.filter(element => element.id == i);

            this.contact_notif.push(element)
          */
          for (let element of this.contactList1.data) {
            //console.log(element)

            if (element.id === i) {
              //console.log(element.id)

              this.contact_notif.push(element)
              this.contact_notif2.push(element.id);

              localStorage.setItem('contact1', this.contact_notif2)
            }
          }
          //console.log(this.contact_notif)
        }
        this.dataSourceC = new MatTableDataSource(this.contact_notif);


      },
      (error) => {
        Swal.fire({
          text: 'Un problème est survenu! ' + error,

        })


      })


  }

  submitForm() {


    /*
        //console.log(this.registerForm)


        //console.log(this.registerForm.value);

        Object.values(this.registerForm).forEach(val => {
          //console.log(val);

        });
        this.submitStatus = true;
        this.listalarm()
        if (this.registerForm.invalid) {
          return;
        }

    */
//console.log(this.idPlan)


    this.registerFormUpdate = this.formBuilder.group({
      // tslint:disable-next-line:quotemar

      filter_id: [this.filter_id],
      frequency: [this.frequence],
      period: [this.periode],
      date: [(<HTMLInputElement>document.getElementById('dateRapport'))?.value?.toString()?.split('00:00:00')[0]],
      wkDay: [this.wkDay],
      day1: [this.day1],
      day2: [this.day2],
      hour: [(<HTMLInputElement>document.getElementById('heureRapport'))?.value],
      contacts: [JSON.stringify(this.contact_notif3)]

    })

    this.http.put(environment.apiUrl + '/reports/scheduler/' + this.idPlan, this.registerFormUpdate.value).subscribe(data => {
        var statuscontact: any = data

        //console.log(data)
        if (statuscontact.status == 200) {
          Swal.fire({
            position: 'center',
            title: 'Rapport modifié  avec succées !',
            allowOutsideClick: false,
            showConfirmButton: false,
            timer: 1000,


          },)

          location.reload()
          localStorage.removeItem('contact1')

        } else {
//console.log('500 status')
          Swal.fire({
            text: statuscontact.message + '!',

          })
        }

      },
      (error) => {
        Swal.fire({
          text: 'Un problème est survenu! ' + error,

        })


      })
    //location.reload()


  }

  submitcontact() {

    //console.log('LKLK'+this.registerFormContact);


    if (this.registerFormContact.invalid) {
      return;
    }
    Object.values(this.registerFormContact).forEach(val => {
      //console.log(val);
    });
    this.submitStatus = true;


    this.http.post(environment.apiUrl + '/companies/' + JSON.parse(localStorage.getItem('currentUser')).company_id + '/contacts', this.registerFormContact.value).subscribe(data => {
        var statuscontact: any = data
        //console.log(data)
        // location.reload()


        if (statuscontact.status == 200) {
          Swal.fire({
            position: 'center',
            title: 'Contact ajouté avec succées !',
            showConfirmButton: false,
            timer: 4000
          },)
          this.getContactSelect()
        } else {
          //console.log('500 status')
          Swal.fire({
            text: statuscontact.message + '!',

          })
        }


      },
      (error) => {
        Swal.fire({
          text: 'Un problème est survenu! ' + error,

        })

        this.spinnerFavorisrep.hide();
      })
    //location.reload()


  }


  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected?.length;
    const numRows = this.dataSource.data?.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {

    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => {
        this.selection.select(row);
      });
  }

  onNoClick(): void {
    this.dialogRef.close();
    localStorage.removeItem('contact1')


  }

  frequence_Change(e) {


    this.registerFormUpdate = this.formBuilder.group({
      // tslint:disable-next-line:quotemar

      filter_id: [this.filter_id],
      frequency: [],
      period: [],
      date: [],
      wkDay: [],
      day1: [],
      day2: [],
      hour: [],
      contacts: []

    })


  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {

    if (!row) {

      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;

    }
    this.ItemSelected = this.selection.selected

    ////console.log(this.ItemSelected)


    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;

  }


  getContact_notif() {

    //console.log()


    this.dataSourceC = new MatTableDataSource(this.contact_notif);

    // this.ELEMENT_DATAFILTER = JSON.stringify(response)

    // this.dataSource = new MatTableDataSource(list);
    //console.log(this.dataSource)

    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;


  }

  Delete_contact(e) {

    //console.log(e)

    this.getContact_notif()
    localStorage.removeItem('contact1')
    this.contact_notif.splice(e, 1);
    this.contact_notif2.splice(e, 1)

    //console.log(this.contact_notif)

    //console.log(this.contact_notif2)

    localStorage.setItem('contact1', this.contact_notif2)


    var ids = localStorage.getItem('contact1')
    //console.log(ids)
    // tslint:disable-next-line:member-ordering


    var ids2 = ids.split(",")
    //console.log(ids2)
    this.contact_notif3 = ids2
    //console.log( this.formBuilder.array(ids2) )


  }

  registerFormUpdate: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemar
    filter_id: [],
    frequency: [],
    period: [],
    date: [],
    wkDay: [],
    day1: [],
    day2: [],
    hour: [],
    contacts: []
  })


  getItem() {

    var ids = localStorage.getItem('contact1')
    //console.log(ids)
    //console.log(this.contact_notif2)
    localStorage.setItem('contact', this.contact_notif2)


    //console.log(this.registerFormUpdate)
  }

  updatenbrjrs(event) {
    this.sliderValue = event.value;
  }

  formatLabel(value: number) {

    return value;

  }


  updatenbrjrs1(event) {
    this.sliderValue1 = event.value;
  }

  formatLabel1(value: number) {

    return value;

  }

  registerFormContact: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemar
    last_name: ['', {
      validators: [Validators.required, Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/)],
      updateOn: "change"
    }],
    email: ['', {
      validators: [
        Validators.required,
        Validators.email
      ], updateOn: "change"
    }],

    gsm_number: [],
    first_name: ['', {
      validators: [Validators.required, Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/)],
      updateOn: "change"
    }],
    company_id: [],
    created_at: [],
    created_by: [],
    id: [],
    updated_at: [],

  })

  //----------------------------------------------------------------------------------------------
  hiddencontenu() {
    this.hiddenContact = 'true';
  }

  public hiddencontenu2() {
    this.hiddenContact = 'jkhjk';
  }


  applyFilter1(event: Event) {
    const filterValue2 = (event.target as HTMLInputElement).value;
    this.dataSourcet.filter = filterValue2.trim().toLowerCase();

    if (this.dataSourcet.paginator) {
      this.dataSourcet.paginator.firstPage();

    }


    this.hiddenContact = 'true'
  }

  getItemDetails3(e) {
    //localStorage.removeItem('contact')
    this.itemSelect3 = e.id;
    this.rapport = e.name;
    this.filter_id = e.id


    this.registerFormUpdate = this.formBuilder.group({
      // tslint:disable-next-line:quotemar
      // tslint:disable-next-line:quotemar
      filter_id: [this.filter_id],
      frequency: [],
      period: [],
      date: [],
      wkDay: [],
      day1: [],
      day2: [],
      hour: [],
      contacts: []
    })


//console.log(this.registerFormUpdate)

//console.log(e)
  }

  getItemDetails2(e) {
    //localStorage.removeItem('contact')
    this.itemSelect2 = e.id;
    this.first_name = e.first_name
    this.last_name = e.last_name

    this.email = e.email
//console.log( e)


//console.log(this.registerFormUpdate.value)

    if (this.registerFormUpdate.invalid) {
      return;
    }

    if (!this.contact_notif.some((item) => item.id == e.id)) {
      this.contact_notif.push(e);
      this.contact_notif2.push(e.id);

      this.selectedRowIndex2 = e.id;
      this.hiddenContact = 'jkhjk';


      localStorage.setItem('contact1', this.contact_notif2)

      var ids = localStorage.getItem('contact1')
      var ids2 = ids.split(",")
      this.contact_notif3 = ids2
//console.log(ids2)
//console.log( this.formBuilder.array(ids2) )


// tslint:disable-next-line:member-ordering
      this.registerFormUpdate = this.formBuilder.group({
        // tslint:disable-next-line:quotemar


        contacts: [JSON.stringify(this.contact_notif3)]


      })


//console.log(this.registerFormUpdate)


    } else {
      Swal.fire({
        position: 'center',
        title: 'Contact déjà selectionné !',
        text: 'Veillez selectionner un autre contact à notifier !',
        showConfirmButton: false,
        timer: 4000
      },)

    }


// this.contact_notif.push(e);
//console.log( this.contact_notif)


  }


  hiddencontenurep() {
    this.hiddenrep = 'true';
  }

  public hiddencontenu2rep() {
    this.hiddenrep = 'jkhjk';
  }

  applyFilter2(event: Event) {
    const filterValue2 = (event.target as HTMLInputElement).value;
    this.dataSourcetrep.filter = filterValue2.trim().toLowerCase();

    if (this.dataSourcetrep.paginator) {
      this.dataSourcetrep.paginator.firstPage();

    }


    this.hiddenrep = 'true'
  }

  getreportSelect() {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.http.get(environment.apiUrl + '/reports/favorite', requestOptions).subscribe((response) => {
        ////console.log(response)
        this.fav_repos_List = response;
        ////console.log('contactList          '+this.contactList);


        this.dataSourcetrep = new MatTableDataSource(this.fav_repos_List);


        this.dataSourcetrep.paginator = this.secondPaginator2;


      },
      (error) => {
        Swal.fire({
          text: 'Un problème est survenu! ' + error,

        })


      })


  }

  async refrech() {

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.http.get(environment.apiUrl + '/companies/' + JSON.parse(localStorage.getItem('currentUser')).company_id + '/contacts', requestOptions).subscribe((response) => {
        //console.log(response)
        this.contactList = response;
        //console.log('contactList'+this.contactList);


        this.dataSourcet = new MatTableDataSource(this.contactList);


        this.dataSourcet.paginator = this.secondPaginator;

        this._snackBar.open('la liste des contacts est actualisée ', 'Fermer', {
          duration: 2500,

        });


      },
      (error) => {
        Swal.fire({
          text: 'Un problème est survenu! ' + error,

        })

      })


  }

  async refrechrepos() {

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.http.get(environment.apiUrl + '/reports/favorite', requestOptions).subscribe((response) => {
        //console.log(response)

        this.fav_repos_List = response;
        ////console.log('contactList          '+this.contactList);


        this.dataSourcetrep = new MatTableDataSource(this.fav_repos_List);


        this.dataSourcetrep.paginator = this.secondPaginator2;

        this._snackBar.open('la liste des rapports favoris est actualisée ', 'Fermer', {
          duration: 2500,

        });


      },
      (error) => {
        Swal.fire({
          text: 'Un problème est survenu! ' + error,

        })

      })


  }

  getContactSelect() {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.http.get(environment.apiUrl + '/companies/' + JSON.parse(localStorage.getItem('currentUser')).company_id + '/contacts', requestOptions).subscribe((response :any) => {
        ////console.log(response)
        this.contactList = response.data;
        ////console.log('contactList          '+this.contactList);
        this.dataSourcet = new MatTableDataSource(this.contactList);
        this.dataSourcet.paginator = this.secondPaginator;

      },
      (error) => {
        Swal.fire({
          text: 'Un problème est survenu! ' + error,

        })


      })


  }


}


@Component({
  selector: 'dialog-elements-example-dialog',
  styleUrls: ['./plannification-report.component.scss'],
  templateUrl: 'Addplan.html',
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: {displayDefaultIndicatorType: false}
  }]
})
export class DialogAddplanrep implements OnInit {
  toppings = new FormControl();
  toppingList: string[] = ['Rapport1', 'Rapport2', 'Rapport3', 'Rapport4', 'Rapport5', 'Rapport6'];
  selected: any
  selected1: any
  selected2: any
  selected3: any
  pageSize: any = 3
  pageSizeOptions: any = [3, 9, 12]
  value: any
  nbr: any
  sliderValue: number;
  sliderValue1: number;
  hiddenContact: string;
  dataSourcet: any;
  dataSourcetrep: any;
  contactList: any = ""
  displayedColumnst: string[] = ['position'];
  displayedColumnrep: string[] = ['position1'];
  displayedColumns: string[] = ['first_name', 'last_name', 'email', 'delete'];
  myControl = new FormControl();
  lengthTotal: any;
  repos: any;
  dataSource: MatTableDataSource<unknown>;
  matcher = new MyErrorStateMatcher();
  tableDataSourceContact: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('secondPaginator', {static: true}) secondPaginator: MatPaginator;
  @ViewChild('secondPaginator2', {static: true}) secondPaginator2: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  contact_notif2: any = [];
  contacts = new FormControl();
  contact_notif: any = [];
  contact_notif3: any = [];
  selectedRowIndex2: any;
  selectedRowIndex3: any;
  itemSelect2: any;
  selectedRow;
  selectedd: boolean;
  ItemSelected: any[];

  first_name: any;
  last_name: any;
  email: any;
  new_contact: boolean;
  submitStatus: boolean;
  selection = new SelectionModel<any>(true, []);
  dataSourceC: MatTableDataSource<unknown>;
  fav_repos_List: any;
  hiddenrep: string;
  periode: any;
  itemSelect3: any;
  frequence: any
  date: any
  date1: any
  wkDay: any
  day1: any
  day2: any
  heure: any
  itemm: any = localStorage.getItem('contact');


  darkTheme: NgxMaterialTimepickerTheme = {
    container: {
      bodyBackgroundColor: '#3B5876',
      buttonColor: '#fff'
    },
    dial: {
      dialBackgroundColor: '#627991',
    },
    clockFace: {
      clockFaceBackgroundColor: '#627991',
      clockHandColor: '#C4CDD6',
      clockFaceTimeInactiveColor: '#fff'
    }
  };

  public startAt = new Date();
  public min = new Date();
  public startMoment = new Date(0, 0, 0);
  rapport: any;
  filter_id: any;
  url: any;

  async ngOnInit(): Promise<void> {

    this.registerForm = this.formBuilder.group({
      // tslint:disable-next-line:quotemar
      // tslint:disable-next-line:quotemar
      filter_id: [],
      frequency: [],
      period: [],
      date: [],
      wkDay: [],
      day1: [],
      day2: [],
      hour: [],
      contacts: []
    })


    this.getContactSelect()
    this.traslateService.UserAlarmEventdataQuote.subscribe(data => {
      this.url = data
    })


    this.itemm = localStorage.getItem('contact')

  }


  constructor(public dialogRef: MatDialogRef<DialogAddplanrep>, private _formBuilder: FormBuilder, public traslateService: TraslateService, private http: HttpClient, private formBuilder: FormBuilder, private _snackBar: MatSnackBar, private spinnerFavorisrep: NgxSpinnerService, private spinnerFavorisrep1: NgxSpinnerService) {
    this.getItem()
    // this.getContact()
    // this.getContact_notif()
    this.getContactSelect()
    this.getreportSelect()

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    //console.log(JSON.parse(localStorage.getItem('currentUser')).company_id)
    this.http.get(environment.apiUrl + '/companies/' + JSON.parse(localStorage.getItem('currentUser')).company_id + '/contacts/all', requestOptions).subscribe((response) => {

        var listContacts: any = response

        this.lengthTotal = listContacts.length


        this.repos = listContacts
        // //console.log(this.repos)


        this.dataSource = new MatTableDataSource(this.repos);
        this.dataSource.paginator = this.paginator;
        this.tableDataSourceContact = this.repos;
        this.dataSource.sort = this.sort;


      },
      (error) => {
        Swal.fire({
          text: 'Un problème est survenu! ' + error,

        })

      })


  }


  add_contact() {
    this.new_contact = !this.new_contact
  }

  onNoClick(): void {
    this.dialogRef.close();
    localStorage.removeItem('contact1')


  }

  frequence_Change(e) {


    this.registerForm = this.formBuilder.group({
      // tslint:disable-next-line:quotemar

      filter_id: [this.filter_id],
      frequency: [],
      period: [],
      date: [],
      wkDay: [],
      day1: [],
      day2: [],
      hour: [],
      contacts: []

    })


  }

  submitForm() {


    this.registerForm = this.formBuilder.group({
      // tslint:disable-next-line:quotemar

      filter_id: [this.filter_id],
      frequency: [this.frequence],
      period: [this.periode],
      date: [(<HTMLInputElement>document.getElementById('dateRapport'))?.value?.toString()?.split('00:00:00')[0]],
      wkDay: [this.wkDay],
      day1: [this.day1],
      day2: [this.day2],
      hour: [(<HTMLInputElement>document.getElementById('heureRapport'))?.value],
      contacts: [JSON.stringify(this.contact_notif3)]

    })


//console.log(this.registerForm)


    //console.log(this.registerForm.value);
    /*
        Object.values(this.registerForm).forEach(val => {
          //console.log(val);

        });
        this.submitStatus = true;
        this.listalarm()
        if (this.registerForm.invalid) {
          return;
        }

    */


    this.http.post(environment.apiUrl + '/reports/scheduler', this.registerForm.value).subscribe(data => {
        var statuscontact: any = data
        this.spinnerFavorisrep.show()
        //console.log(data)
        if (statuscontact.status == 200) {
          this.spinnerFavorisrep.hide()
          localStorage.removeItem('contact1')

          Swal.fire({
            position: 'center',
            title: 'Rapport plannifié avec succées !',
            allowOutsideClick: false,
            showConfirmButton: false,
            timer: 1000,

          },)

          location.reload()
          localStorage.removeItem('contact1')

        } else {
//console.log('500 status')
          Swal.fire({
            text: statuscontact.message + '!',


          })
          this.spinnerFavorisrep.hide()
        }

      },
      (error) => {
        Swal.fire({
          text: 'Un problème est survenu! ' + error,

        })

        this.spinnerFavorisrep.hide();
      })
    //location.reload()


  }

  submitcontact() {

    //console.log('LKLK'+this.registerFormContact);


    if (this.registerFormContact.invalid) {
      return;
    }
    Object.values(this.registerFormContact).forEach(val => {
      //console.log(val);
    });
    this.submitStatus = true;


    this.http.post(environment.apiUrl + '/companies/' + JSON.parse(localStorage.getItem('currentUser')).company_id + '/contacts', this.registerFormContact.value).subscribe(data => {
        var statuscontact: any = data
        //console.log(data)
        // location.reload()


        if (statuscontact.status == 200) {
          Swal.fire({
            position: 'center',
            title: 'Contact ajouté avec succées !',
            showConfirmButton: false,
            timer: 4000
          },)
          this.getContactSelect()
        } else {
          //console.log('500 status')
          Swal.fire({
            text: statuscontact.message + '!',

          })
        }


      },
      (error) => {
        Swal.fire({
          text: 'Un problème est survenu! ' + error,

        })

        this.spinnerFavorisrep.hide();
      })
    //location.reload()


  }


  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected?.length;
    const numRows = this.dataSource.data?.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {

    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => {
        this.selection.select(row);
      });
  }


  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {

    if (!row) {

      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;

    }
    this.ItemSelected = this.selection.selected

    ////console.log(this.ItemSelected)


    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;

  }


  getContact_notif() {


    this.dataSourceC = new MatTableDataSource(this.contact_notif);

    // this.ELEMENT_DATAFILTER = JSON.stringify(response)

    // this.dataSource = new MatTableDataSource(list);

    //console.log(this.dataSource)

    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;


  }

  Delete_contact(e) {

    //console.log(e)

    this.getContact_notif()
    localStorage.removeItem('contact1')
    this.contact_notif.splice(e, 1);
    this.contact_notif2.splice(e, 1)

    //console.log(this.contact_notif)

    //console.log(this.contact_notif2)

    localStorage.setItem('contact1', this.contact_notif2)


    var ids = localStorage.getItem('contact1')
    //console.log(ids)
    // tslint:disable-next-line:member-ordering


    var ids2 = ids.split(",")
    this.contact_notif3 = ids2
    //console.log(ids2)
    //console.log( this.formBuilder.array(ids2) )


    /*  this.registerForm = this.formBuilder.group({

     filter_id:[this.filter_id],
     frequency: [this.frequence],
     period:[this.periode],
     date: [(<HTMLInputElement>document.getElementById('dateRapport')).value?.toString()?.split('00:00:00')[0]],
     wkDay: [this.wkDay],
     day1: [this.day1],
     day2: [this.day2],
     hour: [this.heure],
     contacts : [JSON.stringify(this.contact_notif3)]
      }) */


  }

  registerForm: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemar
    filter_id: [],
    frequency: [],
    period: [],
    date: [],
    wkDay: [],
    day1: [],
    day2: [],
    hour: [],
    contacts: []
  })

  getItem() {

    var ids = localStorage.getItem('contact1')
    //console.log(ids)
    //console.log(this.contact_notif2)
    localStorage.setItem('contact', this.contact_notif2)


    //console.log(this.registerForm)
  }

  updatenbrjrs(event) {
    this.sliderValue = event.value;
  }

  formatLabel(value: number) {

    return value;

  }


  updatenbrjrs1(event) {
    this.sliderValue1 = event.value;
  }

  formatLabel1(value: number) {

    return value;

  }

  registerFormContact: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemar
    last_name: ['', {
      validators: [Validators.required, Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/)],
      updateOn: "change"
    }],
    email: ['', {
      validators: [
        Validators.required,
        Validators.email
      ], updateOn: "change"
    }],

    gsm_number: [],
    first_name: ['', {
      validators: [Validators.required, Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/)],
      updateOn: "change"
    }],
    company_id: [],
    created_at: [],
    created_by: [],
    id: [],
    updated_at: [],

  })

  //----------------------------------------------------------------------------------------------
  hiddencontenu() {
    this.hiddenrep = 'true';
  }

  public hiddencontenu2() {
    this.hiddenrep = 'jkhjk';
  }

  hiddencontenurep() {
    this.hiddenrep = 'true';
  }

  public hiddencontenu2rep() {
    this.hiddenrep = 'jkhjk';
  }

  applyFilter2(event: Event) {
    const filterValue2 = (event.target as HTMLInputElement).value;
    this.dataSourcetrep.filter = filterValue2.trim().toLowerCase();

    if (this.dataSourcetrep.paginator) {
      this.dataSourcetrep.paginator.firstPage();

    }


    this.hiddenrep = 'true'
  }

  applyFilter1(event: Event) {
    const filterValue2 = (event.target as HTMLInputElement).value;
    this.dataSourcet.filter = filterValue2.trim().toLowerCase();

    if (this.dataSourcet.paginator) {
      this.dataSourcet.paginator.firstPage();

    }


    this.hiddenContact = 'true'
  }


  getItemDetails3(e) {
    //localStorage.removeItem('contact')
    this.itemSelect3 = e.id;
    this.rapport = e.name;
    this.filter_id = e.id


    this.registerForm = this.formBuilder.group({
      // tslint:disable-next-line:quotemar
      // tslint:disable-next-line:quotemar
      filter_id: [this.filter_id],
      frequency: [],
      period: [],
      date: [],
      wkDay: [],
      day1: [],
      day2: [],
      hour: [],
      contacts: []
    })


//console.log(this.registerForm)

//console.log(e)
  }

  test() {

    //console.log((<HTMLInputElement>document.getElementById('heureRapport')).value)
  }

  getItemDetails2(e) {
    //localStorage.removeItem('contact')
    this.itemSelect2 = e.id;
    this.first_name = e.first_name
    this.last_name = e.last_name

    this.email = e.email
//console.log( e)


////console.log(this.registerForm.value)

    if (this.registerForm.invalid) {
      return;
    }

    if (!this.contact_notif.some((item) => item.id == e.id)) {
      this.contact_notif.push(e);
      //console.log(this.contact_notif)


      this.contact_notif2.push(e.id);

      this.selectedRowIndex2 = e.id;
      this.hiddenContact = 'jkhjk';


      localStorage.setItem('contact1', this.contact_notif2)
//console.log(this.contact_notif2)

      var ids = localStorage.getItem('contact1')
      var ids2 = ids.split(",")
      this.contact_notif3 = ids2
//console.log(ids2)
//console.log( this.formBuilder.array(ids2))
//console.log(this.contact_notif3)


    } else {
      Swal.fire({
        position: 'center',
        title: 'Contact déjà selectionné !',
        text: 'Veillez selectionner un autre contact à notifier !',
        showConfirmButton: false,
        timer: 4000
      },)

    }


// this.contact_notif.push(e);
//console.log( this.contact_notif)


  }

  async refrech() {

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.http.get(environment.apiUrl + '/companies/' + JSON.parse(localStorage.getItem('currentUser')).company_id + '/contacts', requestOptions).subscribe((response) => {
        //console.log(response)
        this.contactList = response;
        this.spinnerFavorisrep.show()
        //console.log('contactList'+this.contactList);


        this.dataSourcet = new MatTableDataSource(this.contactList);


        this.dataSourcet.paginator = this.secondPaginator;

        this._snackBar.open('la liste des contacts est actualisée ', 'Fermer', {
          duration: 2500,

        });
        this.spinnerFavorisrep.hide()

      },
      (error) => {
        Swal.fire({
          text: 'Un problème est survenu! ' + error,

        })

        this.spinnerFavorisrep.hide();
      })


  }

  async refrechrepos() {

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.http.get(environment.apiUrl + '/reports/favorite', requestOptions).subscribe((response) => {

        this.spinnerFavorisrep1.show()
        this.fav_repos_List = response;
        //console.log(response)
        ////console.log('contactList          '+this.contactList);


        this.dataSourcetrep = new MatTableDataSource(this.fav_repos_List);


        this.dataSourcetrep.paginator = this.secondPaginator2;

        this._snackBar.open('la liste des rapports favoris est actualisée ', 'Fermer', {
          duration: 2500,

        });

        this.spinnerFavorisrep1.hide()
      },
      (error) => {
        Swal.fire({
          text: 'Un problème est survenu! ' + error,

        })

        this.spinnerFavorisrep.hide();
      })


  }

  getContactSelect() {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.http.get(environment.apiUrl + '/companies/' + JSON.parse(localStorage.getItem('currentUser')).company_id + '/contacts/all', requestOptions).subscribe((response: any) => {
        ////console.log(response)
        this.contactList = response;
        ////console.log('contactList          '+this.contactList);


        this.dataSourcet = new MatTableDataSource(this.contactList);


        this.dataSourcet.paginator = this.secondPaginator;


      },
      (error) => {
        Swal.fire({
          text: 'Un problème est survenu! ' + error,

        })

      })


  }

  getreportSelect() {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.http.get(environment.apiUrl + '/reports/favorite/all', requestOptions).subscribe((response: any) => {
        this.fav_repos_List = response.data;
        ////console.log('contactList          '+this.contactList);
        //console.log(this.fav_repos_List)


        this.dataSourcetrep = new MatTableDataSource(this.fav_repos_List);


        this.dataSourcetrep.paginator = this.secondPaginator2;


      },
      (error) => {
        Swal.fire({
          text: 'Un problème est survenu! ' + error,

        })

        this.spinnerFavorisrep.hide();
      })


  }


}


export interface PeriodicElement {
  name: string;
  position: string;
  weight: number;
  symbol: string;
}


const ELEMENT_DATA: PeriodicElement[] = [
  {position: 'Ahmed', name: 'Ahmed@gmail.com', weight: 1.0079, symbol: 'H'},
  {position: 'Ali', name: 'Ali@gmail.com', weight: 4.0026, symbol: 'He'},
  {position: 'marie', name: 'm.r@gmail.com', weight: 6.941, symbol: 'Li'},
  {position: 'Afaf', name: 'Afaf@gmail.com', weight: 9.0122, symbol: 'Be'},

];


@Component({
  selector: 'table_contact_plan',
  styleUrls: ['plannification-report.component.scss'],
  templateUrl: 'tableContactPlan.html',
})
export class Table_contact_plan {
  displayedColumns: string[] = ['position', 'name'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);


  contacts = new FormControl();
  contactList: string[] = ['Ali', 'Afaf', 'Ahmed', 'Amine'];
  new_contact: boolean;


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  add_contact() {
    this.new_contact = true;


  }

  select_contact() {

    this.new_contact = false;


  }

}
